export default {
  state: {
    caseList: null,
    caseTotalCount: null,
    caseSingle: null,
    caseStatistics: null,
    caseStatisticsTotalCount: null,
    caseStatisticsRequestId: null
  },
  mutations: {
    setCaseList (state, payload) {
      state.caseList = []
      state.caseList = payload
    },
    setCaseTotalCount (state, payload) {
      state.caseTotalCount = payload
    },
    setCaseSingle (state, payload) {
      state.caseSingle = payload
    },
    setCaseStatistics (state, payload) {
      state.caseStatistics = payload
    },
    setCaseStatisticsTotalCount (state, payload) {
      state.caseStatisticsTotalCount = payload
    },
    setCaseStatisticsRequestId (state, payload) {
      state.caseStatisticsRequestId = payload
    }
  },
  actions: {
    async getCaseList ({commit, dispatch}, {mode, offset, limit}) {
      const url = '/admin/case/list?access_token=' + this.getters.accessToken + '&mode=' + mode + '&offset=' + offset + '&limit=' + limit
      await dispatch('apiGet', url)
        .then((data) => {
          commit('setCaseList', data.case_list)
          commit('setCaseTotalCount', data.total_count)
        })
        .catch((error) => {
          throw error
        })
    },
    getCaseSingle ({commit, dispatch}, {id}) {
      const url = '/admin/case/' + id + '/single?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setCaseSingle', data.case)
        })
        .catch((error) => {
          throw error
        })
    },
    async deleteCase ({commit, dispatch}, {id}) {
      let post = {
        data: {
          id: id
        }
      }
      console.log('Delete - ' + id)
      post.url = '/admin/case/' + id + '/remove?access_token=' + this.getters.accessToken
      await dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Ограничение удалено успешно')
        })
        .catch((error) => {
          throw error
        })
    },
    async createCase ({commit, dispatch}, caseData) {
      let post = {
        data: {
          title: caseData.title,
          start_date: caseData.startDate,
          end_date: caseData.endDate,
          bonus_percent: caseData.bonusPercent
        }
      }

      if (typeof caseData.bonusMaxSum !== 'undefined') {
        post.data.bonus_max_sum = caseData.bonusMaxSum
      }

      // if (typeof caseData.pointFolderIdList !== 'undefined') {
      //   post.data.point_folder_id_list = caseData.pointFolderIdList
      // }
      // if (typeof caseData.pointIdList !== 'undefined') {
      //   post.data.point_id_list = caseData.pointIdList
      // }
      if (typeof caseData.channelIdList !== 'undefined') {
        post.data.distribution_channel_id_list = caseData.channelIdList
      }
      if (typeof caseData.productGroupList !== 'undefined') {
        post.data.case_product_group_update_list = caseData.productGroupList
      }
      if (typeof caseData.branchIdList !== 'undefined') {
        post.data.branch_id_list = caseData.branchIdList
      }

      let returnData = null
      if (caseData.id === null) {
        post.url = '/admin/case/add?access_token=' + this.getters.accessToken
        await dispatch('apiPost', post)
          .then((data) => {
            commit('setSuccess', 'Кейс создан успешно')
            returnData = data
          })
          .catch((error) => {
            throw error
          })
      } else {
        post.id = caseData.id
        post.url = '/admin/case/' + caseData.id + '/update?access_token=' + this.getters.accessToken

        await dispatch('apiPost', post)
          .then((data) => {
            commit('setSuccess', 'Кейс изменен успешно')
            returnData = data
          })
          .catch((error) => {
            throw error
          })
      }
      return returnData
    },
    getCaseStatistics ({commit, dispatch, state}, {id, q, branchId, saleGroupId, limit, offset}) {
      let urlQ = ''
      if (q !== null && typeof q !== 'undefined') {
        urlQ = '&q=' + q
      }

      let urlSaleGroupId = ''
      if (saleGroupId !== null && typeof saleGroupId !== 'undefined') {
        urlSaleGroupId = '&sale_group_id=' + saleGroupId
      }

      let urlBranchId = ''
      if (branchId !== null && typeof branchId !== 'undefined') {
        urlBranchId = '&branch_id=' + branchId
      }

      let urlOffset = ''
      if (offset !== null && typeof offset !== 'undefined') {
        urlOffset = '&offset=' + offset
      }

      let urlLimit = ''
      if (limit !== null && typeof limit !== 'undefined') {
        urlLimit = '&limit=' + limit
      }

      const url = '/admin/case/' + id + '/statistics/list?access_token=' + this.getters.accessToken + urlQ + urlBranchId + urlSaleGroupId + urlLimit + urlOffset
      let requestId = setTimeout(function () {
        dispatch('apiGet', url)
          .then((data) => {
            if (requestId === state.caseStatisticsRequestId) {
              commit('setCaseStatistics', data.case_statistics_list)
              commit('setCaseStatisticsTotalCount', data.total_count)
            }
          })
          .catch((error) => {
            throw error
          })
      }, 100)
      commit('setCaseStatisticsRequestId', requestId)
    }
  },
  getters: {
    caseList (state) {
      return state.caseList
    },
    caseTotalCount (state) {
      return state.caseTotalCount
    },
    caseSingle (state) {
      return state.caseSingle
    },
    caseStatistics (state) {
      return state.caseStatistics
    },
    caseStatisticsTotalCount (state) {
      return state.caseStatisticsTotalCount
    },
    caseStatisticsRequestId (state) {
      return state.caseStatisticsRequestId
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/case.js